import {Loan} from "Loans/interface";
import {Actions} from "Loans/actions";

export interface IState {
  loansList: Loan[];
  loanIndex: number;
};

const defaultState: IState = {
  loansList: [],
  loanIndex: (sessionStorage.getItem('loanIndex') || sessionStorage.getItem('loanIndex') !== '0') ?
    Number(sessionStorage.getItem('loanIndex')) : null,
};

export default function loanDetails(state = defaultState, action) {
  switch (action.type) {
    case `${Actions.SET_LOAN_LIST}`:
      return {
        ...state,
        loansList: action.body,
      };
    case `${Actions.SET_LOAN_INDEX}`:
      return {
        ...state,
        loanIndex: action.body,
      };
    default:
      return state;
  }
};
